<template>
  <div>
    <Head v-if="route.params?.league && league?.slug">
      <Title>{{ league?.name }} - Fans48</Title>
      <Meta name="description" :content="league?.name" />
    </Head>
    <div class="mx-auto max-w-xl px-2">
      <div v-if="route.params?.league && league?.slug">
        <div class="space-y-3 my-2" v-auto-animate>
          <LeagueBreadcrumbs />
          <LeagueDetails v-if="route.name !== 'leagues-league-game'" />
          <LeagueNav v-if="route.name !== 'leagues-league-game'" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const league = useLeagueStore()
</script>
